import {EnvSetup, getSupportUrl} from "enums/Envs";
import {request} from "services/request";


export interface CustomAction {
    action: string
    description: string
}

export interface SentPushNotification {
    dateSent: string
    eventType: string
    recipientKey: string
    userKey: string
}

export interface PushNotificationSearchGetParams {
    userKey: string;
    dateFrom: Date | null;
    dateTo: Date | null;
    recipientKey: string | undefined | null;
    eventType: 'MatchOnline' | 'NewUserNearby' | 'OutgoingLikeReminder' | 'SmartIntro' | undefined | null;
    skip: number;
    take: number;
}

export interface CustomImport {
    name: string
    category: string
}

export const supportService = {
    getSupportActions: async (env: EnvSetup) => {
        const response = await request<{ actions: CustomAction[] }>({
            method: 'get',
            url: `/${getSupportUrl(env)}/custom-actions`
        });
        return response?.actions ?? []
    },
    execute: async (env: EnvSetup, params: { action: string, userKey: string }) => {
        await request<{ actions: CustomAction[] }>({
            method: 'post',
            url: `/${getSupportUrl(env)}/custom-actions/execute`,
            data: params
        });
    },
    getPushNotifications: async (env: EnvSetup, params: PushNotificationSearchGetParams) => {
        // Build query string from params, filtering out empty values and formatting dates
        const queryParams = new URLSearchParams();

        if (params.userKey) queryParams.append('userKey', params.userKey);
        if (params.recipientKey) queryParams.append('recipientKey', params.recipientKey);
        if (params.eventType) queryParams.append('eventType', params.eventType);
        if (params.dateFrom) queryParams.append('dateFrom', params.dateFrom.toISOString());
        if (params.dateTo) queryParams.append('dateTo', params.dateTo.toISOString());
        queryParams.append('skip', params.skip.toString());
        queryParams.append('take', params.take.toString());

        const queryString = queryParams.toString();
        const url = `/${getSupportUrl(env)}/sent-pushes${queryString ? `?${queryString}` : ''}`;

        return request<{ pushEvents: SentPushNotification[] }>({
            method: 'get',
            url
        });
    },
    getImports: async (env: EnvSetup) => {
        const response = await request<{ importers: CustomImport[] }>({
            method: 'get',
            url: `/${getSupportUrl(env)}/imports`
        });
        return (response?.importers ?? []) as CustomImport[]
    },
    uploadImport: async (
        env: EnvSetup,
        params: { name: string }
    ) => {
        const response = await request<{ log: string[] }>({
            method: 'post',
            url: `/${getSupportUrl(env)}/imports?name=${encodeURIComponent(params.name)}`,
        });
        return response?.log;
    },
}